<template>
  <span class="event-date-share-btn">
    <v-tooltip location="bottom">
      <template v-slot:activator="{ props: tooltipProps }">
        <v-btn
          variant="text"
          icon
          v-bind="{ ...$attrs, ...tooltipProps }"
          @click.stop="handleCopy"
        >
          <v-icon>fal fa-link</v-icon>
        </v-btn>
      </template>
      <span>Share Link</span>
    </v-tooltip>

    <v-snackbar
      v-model="showSnackbar"
      :timeout="3000"
      :color="snackbarColor"
      location="top"
    >
      {{ snackbarMsg }}
      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="showSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </span>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { COMMON_ROUTE_NAMES } from "@common/routing";
import { seriesPurchasePath } from "@common/utils/series-card";

const props = defineProps<{
  eventDate: {
    id: number | string | null;
    eventName?: string | null;
    isSeries?: boolean | null;
    seriesId?: number | null;
  };
}>();

const router = useRouter();

const showSnackbar = ref(false);
const snackbarMsg = ref("");
const snackbarColor = ref("success");

function getShareableUrl(): string {
  // Series rows share the series URL — sharing /event-date/{first-date-id}
  // would point recipients at just one underlying date.
  if (props.eventDate.isSeries && props.eventDate.seriesId) {
    return (
      window.location.origin +
      seriesPurchasePath(props.eventDate.seriesId, props.eventDate.eventName)
    );
  }

  const resolved = router.resolve({
    name: COMMON_ROUTE_NAMES.EventDateSingle,
    params: {
      id: props.eventDate.id,
      name: props.eventDate.eventName?.replace(/\s/g, "") ?? "",
    },
  });
  return window.location.origin + resolved.href;
}

function handleCopy(): void {
  const url = getShareableUrl();
  navigator.clipboard
    .writeText(url)
    .then(() => {
      snackbarMsg.value = "Link copied to clipboard!";
      snackbarColor.value = "success";
      showSnackbar.value = true;
    })
    .catch(() => {
      snackbarMsg.value = "Failed to copy link";
      snackbarColor.value = "error";
      showSnackbar.value = true;
    });
}
</script>
